import { CallOverBankDetails } from "../../models/CallOverBankDetails";
import { CallOverVerificationReducer } from "../../reducers/vendor/CallOverVerificationReducer";

export type CallOverVerificationAction =
  | {
      type: "ON_ENTERING_CALL_OVER_VERIFICATION_DATA";
      payload: [input: string, value: any];
    }
    |{
      type: "ON_ENTERING_CALL_OVER_VERIFICATION_EMAIL";
      payload: [input: string, index: number,  value: any];
    }|
    {
      type: "ON_ENTERING_CALL_OVER_BANK_VERIFICATION_DATA";
      payload: [input: string, index: number, value: any];
    }|
     {
      type: "ADD_EMPTY_CALL_OVER_VERIFICATION_EMAIL";
      payload: [itemlength: number];
    }|
    {
      type: "ADD_EMPTY_CALL_OVER_VERIFICATION_BANKS";
      payload: [itemlength: number];
    }|{
      type: "RESET_CALLOVER";
      payload: [];
    };

    const onValidateBankField=(input: string,index: number, value: any): CallOverVerificationAction=> {
      return {
        type: "ON_ENTERING_CALL_OVER_BANK_VERIFICATION_DATA",
        payload: [input, index, value],
      };
    }

    const onValidateField=(input: string, value: any): CallOverVerificationAction=> {
        return {
          type: "ON_ENTERING_CALL_OVER_VERIFICATION_DATA",
          payload: [input, value],
        };
      }
      const onValidateEmail=(input: string,index: number, value: any): CallOverVerificationAction=> {
        return {
          type: "ON_ENTERING_CALL_OVER_VERIFICATION_EMAIL",
          payload: [input,index, value],
        };
      }
      const addEmptyEmails=(itemlength:number): CallOverVerificationAction=> {
        return {
          type: "ADD_EMPTY_CALL_OVER_VERIFICATION_EMAIL",
          payload: [itemlength],
        };
      }
      
      const addEmptyBankDetails=(itemlength:number): CallOverVerificationAction=> {
        return {
          type: "ADD_EMPTY_CALL_OVER_VERIFICATION_BANKS",
          payload: [itemlength],
        };
      }
      

      const  resetVendorCallover = ():CallOverVerificationAction =>{
        return {
          type: "RESET_CALLOVER",
          payload: [],
        };
      }

      export const CallOverVerificationActions = {
        onValidateField,
        onValidateEmail,
        addEmptyEmails,
        addEmptyBankDetails,
        resetVendorCallover,
        onValidateBankField
      };